import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { withToken } from '../../../../services/client'
import { GET_PAGE } from '../../../../services/graphql/queries/getPage'
import Error from 'next/error'
import { useMemo } from 'react'
import SellerLayout from '../../../../components/layouts/backend/sidebar/SellerLayout'
import CmsComponent from '../../../../components/CmsComponent'
import sellerOnlyPages from '../../../../services/sellerOnlyPages'
import CmsHeadComponent from '../../../../components/CmsHeadComponent'

export default function Page ({ page }) {
  if (!page) {
    return <Error statusCode={404} />
  }

  const fields = useMemo(() => page.attributes)

  return (
    <SellerLayout
      classNameContent="bg-light cms"
    >
      <CmsHeadComponent fields={fields} />
      <div className="backend-container bg-light-blue p-md-5 p-3">
        <div className="container pb-5">
          {
            fields.block.map((block, index) => (
              <CmsComponent
                typename={block.__typename}
                props={block}
                index={index}
                key={index}
              />
            ))
          }
        </div>
      </div>

    </SellerLayout>
  )
}

export async function getServerSideProps ({ locale, query: { slug } }) {
  const { isSellerOnlyPage } = sellerOnlyPages()

  let page = false

  if (!isSellerOnlyPage(slug)) {
    return
  }

  try {
    const { data } = await withToken(process.env.NEXT_PUBLIC_CMS_PUBLIC_TOKEN, locale, process.env.NEXT_PUBLIC_CMS_GRAPHQL_URL).query({
      query: GET_PAGE,
      fetchPolicy: 'no-cache',
      variables: {
        slug,
        locale
      }
    })

    page = data.pages.data.length ? data.pages.data[0] : false
  } catch (e) {
    console.log(e)
  }

  return {
    props: {
      page,
      ...(await serverSideTranslations(locale, ['header', 'footer', 'languages', 'applications']))
    }
  }
}
